export const GET_CUSTOMERS_OF_MERCHANT_REQUEST =
  'GET_CUSTOMERS_OF_MERCHANT_REQUEST';
export const GET_CUSTOMERS_OF_MERCHANT_SUCCESS =
  'GET_CUSTOMERS_OF_MERCHANT_SUCCESS';
export const GET_CUSTOMERS_PAGINATION_SUCCESS =
  'GET_CUSTOMERS_PAGINATION_SUCCESS';
